"use client";

import React, { useState, useEffect, useCallback } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SonicArchitecture() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const handleMouseMove = useCallback((e: React.MouseEvent<HTMLElement>) => {
    if (!isMounted) return;
    const {
      clientX,
      clientY
    } = e;
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;
    const moveX = (clientX - centerX) * 0.03;
    const moveY = (clientY - centerY) * 0.03;
    setMousePos({
      x: moveX,
      y: moveY
    });
  }, [isMounted]);
  return <section data-section-id="265278" id="sonic-architecture" className="bg-background text-foreground relative h-screen w-full overflow-hidden flex flex-col items-center justify-center" onMouseMove={handleMouseMove}>
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/hero_background_visible.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/hero_background_visible.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689780/img/hero_background_visible.png-wvc-sizes" alt="Rhythm & Soul Studio" className="w-full h-full object-cover scale-105" loading="eager" />
        <div className="absolute inset-0 bg-black/90 backdrop-blur-[1px]"></div>
      </div>

      {}
      <div className="relative z-10 flex items-center justify-center pointer-events-none w-full h-full" style={{
      transform: `translate(${mousePos.x}px, ${mousePos.y}px)`,
      transition: "transform 0.1s ease-out"
    }}>
        <h1 className="text-[12vw] md:text-[12vw] lg:text-[12vw] font-bold font-default leading-none tracking-tighter text-white select-none drop-shadow-md uppercase text-center">
          Sonic Architecture
        </h1>
        {}
        <h1 className="absolute text-[12vw] md:text-[12vw] lg:text-[12vw] font-bold font-default leading-none tracking-tighter text-transparent select-none opacity-40 uppercase text-center" style={{
        WebkitTextStroke: "1px rgba(255,255,255,0.8)",
        transform: "translate(-4px, -4px)"
      }}>
          Sonic Architecture
        </h1>
      </div>

      {}
      <div className="absolute bottom-20 left-0 w-full flex flex-col items-center justify-center z-20 gap-10 px-4">
        <div className="flex flex-col items-center gap-2 text-white/40 animate-pulse">
          <div className="w-[1px] h-12 bg-white/60"></div>
          <span className="text-[10px] tracking-[0.5em] uppercase font-mono">Scroll</span>
        </div>
      </div>
    </section>;
}